import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { NotificationService } from '../../../core/services/notification.service';
import { TranslationService } from '../../../core/services/i18n/translation.service';
import { MESSAGE_STYLE, MessageKind } from '../../../core/utils/status-tone';

@Component({
  selector: 'app-notification-toast',
  standalone: true,
  imports: [CommonModule, CdkTrapFocus],
  templateUrl: './notification-toast.component.html',
})
export class NotificationToastComponent {
  notificationService = inject(NotificationService);
  translationService = inject(TranslationService);

  /** The kind of message is in the icon; the colours stay white, gray, black and orange (card 949) */
  readonly style = MESSAGE_STYLE;

  /** A confirm dialog's kind as a message kind: "danger" asks about something that cannot be undone */
  confirmKind(type: 'danger' | 'warning' | 'info' | undefined): MessageKind {
    return type === 'danger' ? 'error' : (type ?? 'info');
  }

  /** A click on the dark backdrop keeps the focus in the confirm; the browser would move it to the page behind */
  keepFocusInside(event: MouseEvent): void {
    if (event.target === event.currentTarget) event.preventDefault();
  }

  /** Escape cancels the confirm only: the screen it was asked from (the verifier, a modal) listens for Escape too */
  cancelOnEscape(event: Event): void {
    event.stopPropagation();
    this.notificationService.confirmNo();
  }

  close(id: string): void {
    this.notificationService.remove(id);
  }
}
